module.exports = __webpack_public_path__ + "static/img/3.d4ae361.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/3.png
// module id = XvyO
// module chunks = 2